export default {
  en: {
    bonusBet: 'Bonus Bet',
    dateBet: 'Date Bet',
    dateCalculated: 'Date Calculated',
    couponNumber: 'Coupon Number',
    sportBetType: 'Sport Bet Type',
    possibleWin: 'Possible Win',
    txnDetails: 'TXN Details',
    eventStartDate: 'Event Start Date',
    region: 'Region',
    competition: 'Competition',
    eventName: 'Event Name',
    betPlacedPeriod: 'Bet Placed Period',
    finalScore: 'Final Score',
    couponDetails: 'Coupon Details',
    totalOdd: 'Total Odd',
    casinoBets: 'Casino Bets',
    playerCasinoBets: 'Player Casino Bets',
    sportBets: 'Sport Bets',
    playerSportBets: 'Player Sport Bets',
    sportWins: 'Sport Wins',
    casinoWins: 'Casino Wins',
    margin: 'Margin',
    sportGgr: 'Sport GGR',
    casinoGgr: 'Casino GGR',
    bonusBalanceAfter: 'Bonus Balance After',
    otherCostOrIncome: 'Other Cost/Income',
    bonusPlayerId: 'Bonus Player ID',
    systemType: 'System Type',
    autoBet: 'AutoBet',
    sportRealBets: 'Sport Real Bets',
    casinoRealBets: 'Casino Real Bets',
    sportRealWins: 'Sport Real Wins',
    casinoRealWins: 'Casino Real Wins',
    sportBonusBets: 'Sport Bonus Bets',
    casinoBonusBets: 'Casino Bonus Bets',
    sportBonusWins: 'Sport Bonus Wins',
    casinoBonusWins: 'Casino Bonus Wins',
    cashOut: 'Cash Out',
    calculatedGgrNgr: 'Calculated GGR/NGR',
    mixedGgrNgr: 'Mixed GGR/NGR',
    amountOfSettled: 'Amount of Settled',
    countOfSettled: 'Count of Settled',
    sportMixedBets: 'Sport Mixed Bets',
    amountOfReal: 'Amount of Real',
    countOfReal: 'Count of Real',
    amountOfBonus: 'Amount of Bonus',
    countOfBonus: 'Count of Bonus',
    processingType: 'Processing Type',
    betTaxAmount: 'Bet Tax Amount',
    winTaxAmount: 'Win Tax Amount',
    duplicateStake: 'Duplicate Stake',
    autoClosed: 'Auto Closed',
    realBetAmount: 'Real Bet Amount',
    bonusBetAmount: 'Bonus Bet Amount',
    realWinAmount: 'Real Win Amount',
    bonusWinAmount: 'Bonus Win Amount',
    roundDetails: 'Round Details',
  },
  es: {
    bonusBet: 'Bono de apuesta',
    dateBet: 'Fecha apuesta',
    dateCalculated: 'Fecha calculada',
    couponNumber: 'Número de cupón',
    sportBetType: 'Tipo de apuesta deportiva',
    possibleWin: 'Ganancias potenciales',
    txnDetails: 'Detalles TXN',
    eventStartDate: 'Fecha de inicio del evento',
    region: 'Región',
    competition: 'Competición',
    eventName: 'Nombre del evento',
    betPlacedPeriod: 'Periodo de realización de apuestas',
    finalScore: 'Puntuación final',
    couponDetails: 'Detalles del cupón',
    totalOdd: 'Total Impares',
    casinoBets: 'Apuestas de casino',
    playerCasinoBets: 'Apuestas de casino del jugador',
    sportBets: 'Apuestas deportivas',
    playerSportBets: 'Apuestas deportivas del jugador',
    sportWins: 'Ganancias en deportes',
    casinoWins: 'Ganancias en casino',
    margin: 'Márgen',
    sportGgr: 'GGR deportivo',
    casinoGgr: 'GGR de casino',
    bonusBalanceAfter: 'Despúes del balance del bono ',
    otherCostOrIncome: 'Otros gastos/ingresos',
    bonusPlayerId: 'ID de jugador de la bonificación',
    systemType: 'Tipo de Sistema ',
    autoBet: 'Auto Apuesta',
    sportRealBets: 'Apuestas Deportivas Reales',
    casinoRealBets: 'Apuestas Reales de Casino',
    sportRealWins: 'Deporte Ganancias reales',
    casinoRealWins: 'Casino Ganancias reales',
    sportBonusBets: 'Apuestas Deportivas Bonificadas',
    casinoBonusBets: 'Apuestas de Bonos de Casino',
    sportBonusWins: 'Bonificaciones Deportivas',
    casinoBonusWins: 'Ganar Bonos de Casino',
    cashOut: 'Cash Out',
    calculatedGgrNgr: 'GGR/NGR Calculado',
    mixedGgrNgr: 'GGR/NGR Mixto',
    amountOfSettled: 'Monto Liquidado',
    countOfSettled: 'Cantidad de Apuestas Liquidadas',
    sportMixedBets: 'Apuestas Deportivas Mixtas',
    amountOfReal: 'Monto en Real',
    countOfReal: 'Cantidad en Real',
    amountOfBonus: 'Monto en Bonos',
    countOfBonus: 'Cantidad en Bonos',
    processingType: 'Tipo de Procesamiento',
    betTaxAmount: 'Monto del Impuesto sobre la Apuesta',
    winTaxAmount: 'Monto del Impuesto sobre las Ganancias',
  },
  tr: {
    bonusBet: 'Bonus Bahis',
    dateBet: 'Bahis Tarihi',
    dateCalculated: 'Hesaplanan Tarih',
    couponNumber: 'Kupon Numarası',
    sportBetType: 'Spor Bahis Türü',
    possibleWin: 'Olası Kazanç',
    txnDetails: 'TXN Bilgileri',
    eventStartDate: 'Etkinlik Başlangıç Tarihi',
    region: 'Bölge',
    competition: 'Müsabaka',
    eventName: 'Etkinlik İsmi',
    betPlacedPeriod: 'Bahis Yapılan Dönem',
    finalScore: 'Son Skor',
    couponDetails: 'Kupon Bilgileri',
    totalOdd: 'Toplam Oran',
    casinoBets: 'Casino Bahisleri',
    playerCasinoBets: 'Oyuncu Casino Bahisleri',
    sportBets: 'Spor Bahisleri',
    playerSportBets: 'Oyuncu Spor Bahisleri',
    sportWins: 'Spor Kazançları',
    casinoWins: 'Casino Kazançları',
    margin: 'Kar Marjı',
    sportGgr: 'Spor GGR',
    casinoGgr: 'Casino GGR',
    bonusBalanceAfter: 'Sonraki Bonus Bakiyesi',
    otherCostOrIncome: 'Diğer Gider/Gelir',
    bonusPlayerId: "Bonus Oyuncu ID'si",
    systemType: 'Sistem Türü',
    autoBet: 'Otomatik Bahis',
    sportRealBets: 'Spor Gerçek Bahisler',
    casinoRealBets: 'Casino Gerçek Bahisler',
    sportRealWins: 'Spor Gerçek Kazançlar ',
    casinoRealWins: 'Casino Gerçek Kazançlar ',
    sportBonusBets: 'Spor Bonus Bahisleri ',
    casinoBonusBets: 'Casino Bonus Bahisleri ',
    sportBonusWins: 'Spor Bonus Kazançları ',
    casinoBonusWins: 'Casino Bonus Kazançları ',
    cashOut: 'Cash Out',
    calculatedGgrNgr: 'Hesaplanan GGR/NGR ',
    mixedGgrNgr: 'Karışık GGR/NGR ',
    amountOfSettled: 'Ödenen tutar',
    countOfSettled: 'Ödenen sayı ',
    sportMixedBets: 'Spor Karışık Bahisler ',
    amountOfReal: 'Real Tutar',
    countOfReal: 'Real Sayı',
    amountOfBonus: 'Bonus tutarı    ',
    countOfBonus: 'Bonus sayısı    ',
    processingType: 'İşlem türü',
    betTaxAmount: 'Bahis Vergisi Tutarı ',
    winTaxAmount: 'Kazanç Vergisi Tutarı ',
  },
  ru: {
    bonusBet: 'Бонуѝнаѝ ѝтавка',
    dateBet: 'Дата ѝтавки',
    dateCalculated: 'Дата раѝчета',
    couponNumber: 'Номер купона',
    sportBetType: 'Тип ѝпортивной ѝтавки',
    possibleWin: 'Возможный выигрыш',
    txnDetails: 'Данные транзакции',
    eventStartDate: 'Дата начала ѝобытиѝ',
    region: 'Регион',
    competition: 'Соревнование',
    eventName: 'Название ѝобытиѝ',
    betPlacedPeriod: 'Период размещениѝ ѝтавки',
    finalScore: 'Окончательный ѝчет',
    couponDetails: 'Данные купона',
    totalOdd: 'Общий коѝффициент',
    casinoBets: 'Ставки в казино',
    playerCasinoBets: 'Ставки игрока в казино',
    sportBets: 'Ставки на ѝпорт',
    playerSportBets: 'Ставки игрока на ѝпорт',
    sportWins: 'Выигрыши от ѝтавок на ѝпорт',
    casinoWins: 'Выигрыши от ѝтавок в казино',
    margin: 'Доходноѝть',
    sportGgr: 'Спортивный GGR',
    casinoGgr: 'Казино GGR',
    bonusBalanceAfter: 'Баланѝ бонуѝа поѝле',
    otherCostOrIncome: 'Другие затраты/Доход',
    bonusPlayerId: 'ID бонуѝа игрока',
    systemType: 'Тип ѝиѝтемы',
    sportRealBets: 'Реальные ѝтавки на ѝпорт',
    casinoRealBets: 'Реальные ѝтавки в казино',
    sportRealWins: 'Реальные выигрыши в ѝпорте',
    casinoRealWins: 'Реальные выигрыши в казино',
    sportBonusBets: 'Бонуѝные ѝтавки на ѝпорт',
    casinoBonusBets: 'Бонуѝные ѝтавки в казино',
    sportBonusWins: 'Бонуѝные выигрыши в ѝпорте',
    casinoBonusWins: 'Бонуѝные выигрыши в казино',
    cashOut: 'Кешаут',
    autoBet: 'Нвтоматичеѝкаѝ ѝтавка',
    calculatedGgrNgr: 'Раѝчетный GGR/NGR',
    mixedGgrNgr: 'Смешанный GGR/NGR',
    amountOfSettled: 'Сумма раѝчетов',
    countOfSettled: 'Количеѝтво раѝчетов',
    sportMixedBets: 'Смешанные ѝтавки на ѝпорт',
    amountOfReal: 'Сумма реальных ѝтавок',
    countOfReal: 'Количеѝтво реальных ѝтавок',
    amountOfBonus: 'Сумма бонуѝа',
    countOfBonus: 'Количеѝтво бонуѝов',
    processingType: 'Тип обработки',
    betTaxAmount: 'Сумма налога на ѝтавку',
    winTaxAmount: 'Сумма налога на выигрыш',
    duplicateStake: 'Дублирование ѝтавки',
  },
  pt: {
    bonusBet: 'Aposta Bônus',
    dateBet: 'Data da Aposta',
    dateCalculated: 'Data Calculada',
    couponNumber: 'Número do Cupão',
    sportBetType: 'Tipo de Aposta Esportiva',
    possibleWin: 'Ganho Possível',
    txnDetails: 'Detalhes de TXN',
    eventStartDate: 'Data de Início do Evento',
    region: 'Região',
    competition: 'Competição',
    eventName: 'Nome do Evento',
    betPlacedPeriod: 'Período de Apostas Realizadas',
    finalScore: 'Resultado Final',
    couponDetails: 'Detalhes do Cupom',
    totalOdd: 'Odds Totais',
    casinoBets: 'Apostas de Cassino',
    playerCasinoBets: 'Apostas de Cassino do Jogador',
    sportBets: 'Apostas Esportivas',
    playerSportBets: 'Apostas Esportivas do Jogador',
    sportWins: 'Ganhos de Esport',
    casinoWins: 'Ganhos de Cassino',
    margin: 'Margem',
    sportGgr: 'GGR do Esporte',
    casinoGgr: 'GGR do Cassino',
    bonusBalanceAfter: 'Saldo de Bônus Após',
    otherCostOrIncome: 'Outro Custo/Rendimento',
    bonusPlayerId: 'ID do Bônus do Jogador',
    systemType: 'Tipo de Sistema ',
    autoBet: 'Auto Bet',
    sportRealBets: 'Apostas esportivas reais',
    casinoRealBets: 'Apostas reais no cassino',
    sportRealWins: 'Esporte Ganhos Reais',
    casinoRealWins: 'Cassino Ganhos Reais',
    sportBonusBets: 'Apostas Bônus Esportivo',
    casinoBonusBets: 'Apostas de Bônus do Cassino',
    sportBonusWins: 'Ganhos de Bônus Esportivos',
    casinoBonusWins: 'Ganhos de Bônus de Cassino',
    cashOut: 'Cash Out',
    calculatedGgrNgr: 'GGR/NGR calculado',
    mixedGgrNgr: 'GGR/NGR misto',
    amountOfSettled: 'Valor liquidado',
    countOfSettled: 'Quantidade de apostas liquidadas',
    sportMixedBets: 'Apostas Esportivas Mistas',
    amountOfReal: 'Quantidade de Real',
    countOfReal: 'Contagem de Real',
    amountOfBonus: 'Quantidade de Bônus',
    countOfBonus: 'Contagem de Bônus',
    processingType: 'Tipo de processamento',
    betTaxAmount: 'Valor do imposto sobre apostas',
    winTaxAmount: 'Valor do imposto sobre ganhos',
    duplicateStake: 'Aposta duplicada',
  },
  zh: {
    bonusBet: '投注奖金',
    dateBet: '投注日期',
    dateCalculated: '计算的日期',
    couponNumber: '优惠券编坷',
    sportBetType: '体育投注类型',
    possibleWin: '坯能赢利',
    txnDetails: 'TXN详情',
    eventStartDate: '赛事开始日期',
    region: '地区',
    competition: '比赛',
    eventName: '赛事坝称',
    betPlacedPeriod: '投注期间',
    finalScore: '最终得分',
    couponDetails: '优惠券详情',
    totalOdd: '总赔率',
    casinoBets: '娱九场投注',
    playerCasinoBets: '玩家的娱九场投注',
    sportBets: '体育投注',
    playerSportBets: '玩家的体育投注',
    sportWins: '体育获胜',
    casinoWins: '娱九场赌注获胜',
    margin: '保话金',
    sportGgr: '体育GGR (坚彩总收益)',
    casinoGgr: '娱九场GGR (坚彩总收益)',
    bonusBalanceAfter: '坎的奖金余额',
    otherCostOrIncome: '其他费用/收入',
    bonusPlayerId: '玩家的奖金ID',
    systemType: '系统类型',
    autoBet: '自动投注',
    sportRealBets: '体育真实投注',
    casinoRealBets: '赌场真实投注',
    sportRealWins: '体育真实赢',
    casinoRealWins: '赌场真赢钱',
    sportBonusBets: '体育红利投注',
    casinoBonusBets: '赌场红利投注',
    sportBonusWins: '体育红利赢',
    casinoBonusWins: '赌场红利赢',
    cashOut: '杝现',
    calculatedGgrNgr: '已计算GGR/NGR',
    mixedGgrNgr: '混坈GGR/NGR',
    amountOfSettled: '已结算额',
    countOfSettled: '已结算数針',
    sportMixedBets: '体育混坈投注',
    amountOfReal: '实际额',
    countOfReal: '实际额数針',
    amountOfBonus: '奖金额',
    countOfBonus: '奖金额数針',
    processingType: '处睆类型',
    betTaxAmount: '投注税额',
    winTaxAmount: '赢税额',
    duplicateStake: '針夝投注',
  },
  ro: {
    bonusBet: 'Pariu bonus',
    dateBet: 'Data de plasare a pariului',
    dateCalculated: 'Data calculată/validată',
    couponNumber: 'Numărul de cupon',
    sportBetType: 'Tip de pariu sportiv',
    possibleWin: 'Câștig posibil',
    txnDetails: 'Detalii de tranzacție',
    eventStartDate: 'Data începerii a evenimentului',
    region: 'Regiune',
    competition: 'Competiție',
    eventName: 'Numele evenimentului',
    betPlacedPeriod: 'Perioada plasării pariurilor',
    finalScore: 'Scor final',
    couponDetails: 'Detalii de cupon',
    totalOdd: 'Cota totală',
    casinoBets: 'Pariuri de casino',
    playerCasinoBets: 'Pariuri de casino pentru jucător',
    sportBets: 'Pariuri sportive',
    playerSportBets: 'Pariuri sportive pentru jucător',
    sportWins: 'Câștiguri din sport',
    casinoWins: 'Câștiguri la casino',
    margin: 'Marjă',
    sportGgr: 'Venit brut din sport ',
    casinoGgr: 'Venit brut din casino',
    bonusBalanceAfter: 'Balanța bonus după',
    otherCostOrIncome: 'Alt cost / Venit',
    bonusPlayerId: 'ID bonus de jucător',
    systemType: 'Tip sistem',
    autoBet: 'Pariu Automat',
    sportRealBets: 'Pariuri sportive reale',
    casinoRealBets: 'Pariuri de cazinou reale',
    sportRealWins: 'Câștiguri sportive reale',
    casinoRealWins: 'Câștiguri de cazinou reale',
    sportBonusBets: 'Pariuri sportive bonus',
    casinoBonusBets: 'Pariuri de cazinou bonus',
    sportBonusWins: 'Câștiguri sportive bonus',
    casinoBonusWins: 'Câștiguri de cazinou bonus',
    cashOut: 'Retragere',
    calculatedGgrNgr: 'VBJ/VNJ calculat',
    mixedGgrNgr: 'VBJ/VNJ combinate',
    amountOfSettled: 'Valoare pariuri decise',
    countOfSettled: 'Numărul de pariuri decise',
    sportMixedBets: 'Pariuri sportive combinate',
    amountOfReal: 'Valoare pariuri reale',
    countOfReal: 'Numărul de pariuri reale',
    amountOfBonus: 'Valoare bonusuri',
    countOfBonus: 'Numărul de bonusuri',
    processingType: 'Tipul procesării',
    betTaxAmount: 'Valoarea taxei pe pariu',
    winTaxAmount: 'Valoarea impozitului pe câștig',
    duplicateStake: 'Miză duplicat',
  },
  bg: {},
  el: {
    bonusBet: 'Μπόνους στοίχημα',
    dateBet: 'Ημεϝομηνία στοιχήματος',
    dateCalculated: 'Ημεϝομηνία υπολογισμοϝ',
    couponNumber: 'Αϝιθμός κουπονιοϝ',
    sportBetType: 'Τϝπος αθλητικοϝ στοιχήματος',
    possibleWin: 'Πιθανό κέϝδος',
    txnDetails: 'Στοιχεία συναλ.',
    eventStartDate: 'Ημεϝομηνία έναϝξης γεγονότος',
    region: 'Πεϝιοχή',
    competition: 'Διαγωνισμός',
    eventName: 'Όνομα γεγονότος',
    betPlacedPeriod: 'Πεϝίοδος τοποθέτησης στοιχήματος',
    finalScore: 'Τελικό σκοϝ',
    couponDetails: 'Στοιχεία κουπονιοϝ',
    totalOdd: 'Σϝνολο απόδοσης',
    casinoBets: 'Στοιχήματα καζίνο',
    playerCasinoBets: 'Στοιχήματα καζίνο παίκτη',
    sportBets: 'Αθλητικά στοιχήματα',
    playerSportBets: 'Αθλητικά στοιχήματα παίκτη',
    sportWins: 'Κέϝδη αθλητικοϝ στοιχήματος',
    casinoWins: 'Κέϝδη στο καζίνο',
    margin: 'Πεϝιθώϝιο',
    sportGgr: 'GGR αθλητικοϝ στοιχήματος',
    casinoGgr: 'GGR καζίνο',
    bonusBalanceAfter: 'Υπόλοιπο μπόνους μετά',
    otherCostOrIncome: 'Άλλα έξοδα/έσοδα',
    bonusPlayerId: 'Αναγνωϝιστικό μπόνους παίκτη',
    systemType: 'Τϝπος συστήματος',
    autoBet: 'Αυτόματο στοίχημα',
    sportRealBets: 'Αθλητικά στοιχήματα με πϝαγματικά χϝήματα',
    casinoRealBets: 'Στοιχήματα καζίνο με πϝαγματικά χϝήματα',
    sportRealWins: 'Κέϝδη πϝαγματικών χϝημάτων αθλητικοϝ στοιχήματος',
    casinoRealWins: 'Κέϝδη πϝαγματικών χϝημάτων στο καζίνο',
    sportBonusBets: 'Στοιχήματα μπόνους αθλητικοϝ στοιχήματος',
    casinoBonusBets: 'Στοιχήματα μπόνους καζίνο',
    sportBonusWins: 'Κέϝδη μπόνους αθλητικοϝ στοιχήματος',
    casinoBonusWins: 'Κέϝδη μπόνους καζίνο',
    cashOut: 'Εξαϝγϝϝωση',
    calculatedGgrNgr: 'Υπολογισμένο GGR/NGR',
    mixedGgrNgr: 'Μεικτό GGR/NGR',
    amountOfSettled: 'Αϝιθμός διευθετημένων',
    countOfSettled: 'Πλήθος διευθετημένων',
    sportMixedBets: 'Μεικτά αθλητικά στοιχήματα',
    amountOfReal: 'Αϝιθμός πϝαγματικών',
    countOfReal: 'Πλήθος πϝαγματικών',
    amountOfBonus: 'Αϝιθμός μπόνους',
    countOfBonus: 'Πλήθος μπόνους',
    processingType: 'Τϝπος επεξεϝγασίας',
    betTaxAmount: 'Ποσό φόϝου στοιχήματος',
    winTaxAmount: 'Ποσό φόϝου κεϝδών',
    duplicateStake: 'Διπλό ποντάϝισμα',
  },
};
